import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["email", "size"];
import { UnauthedHubSpotUserAvatar } from 'avatar-components/UnauthedHubSpotUserAvatar';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewSenderAvatar = _ref => {
  let {
      email,
      size = 'sm'
    } = _ref,
    others = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UnauthedHubSpotUserAvatar, Object.assign({
    hubSpotUserEmail: email,
    size: size
  }, others));
};
export default ViewSenderAvatar;